import React from 'react';

const SIZE_MAP = {
  xs: 'w-5 h-5 text-[8px]',
  sm: 'w-6 h-6 text-[9px]',
  md: 'w-8 h-8 text-[10px]',
  lg: 'w-10 h-10 text-xs',
  xl: 'w-12 h-12 text-sm',
  '2xl': 'w-16 h-16 text-base',
};

const initialsFor = (input) => {
  if (!input) return '?';
  return String(input)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(s => s[0])
    .join('')
    .toUpperCase() || '?';
};

/**
 * Avatar — image when available, teal-gradient initials fallback otherwise.
 * Usage: <Avatar src={user.avatar_url} name={user.full_name} size="md" />
 */
export default function Avatar({
  src,
  name,
  size = 'md',
  className = '',
  ring = false,
  title,
  testId,
}) {
  const sizeCls = SIZE_MAP[size] || SIZE_MAP.md;
  const ringCls = ring ? 'ring-2 ring-white dark:ring-slate-800' : '';
  const initials = initialsFor(name);

  if (src) {
    return (
      <img
        src={src}
        alt={name || 'avatar'}
        title={title || name || ''}
        className={`${sizeCls} ${ringCls} rounded-full object-cover bg-slate-200 ${className}`}
        data-testid={testId}
      />
    );
  }
  return (
    <div
      title={title || name || ''}
      className={`${sizeCls} ${ringCls} rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 text-white font-bold flex items-center justify-center select-none ${className}`}
      data-testid={testId}
    >
      {initials}
    </div>
  );
}
